var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-wrap items-center justify-start"},_vm._l((_vm.items),function(item,index){return _c('span',{key:index,staticClass:"font-rubik font-light text-tiny lg:text-xs mr-2.5 last:mr-0"},[_c('span',{staticClass:"pr-1"},[_vm._v("·")]),_vm._v(" "+_vm._s(item)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }